import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'caret-left', 'IconCaretLeft', [["path",{"d":"M14 6l-6 6l6 6v-12","key":"svg-0"}]]);